const DriverPriceRoutes = {
  createDriver: "/createDriver",
  getDriver: "/getDriver",
  updateDriver: "/updateDriver",
  deleteDriver: "/deleteDriver",
};

export default DriverPriceRoutes;
